import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityUsersFetchFailedAction = {
	type: 'FACILITY_USERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityUsersFetchFailedAction => ({
	type: 'FACILITY_USERS_FETCH_FAILED',
	payload,
});
